"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createTotalUrineAnalysis = createTotalUrineAnalysis;
const events_1 = require("../../../events");
const totalUrineAnalysis_1 = require("../../../forms/ktx/transplantation-screening/lab-procedures/totalUrineAnalysis");
const queries_1 = require("../queries");
const messages = {
    totalUrineAnalysis: {
        id: "ktx.dashboard.total_urine_analysis.title",
        defaultMessage: "Teljes vizelet"
    },
    pH: {
        id: "ktx.dashboard.total_urine_analysis.ph",
        defaultMessage: "pH"
    },
    gravity: {
        id: "ktx.dashboard.total_urine_analysis.gravity",
        defaultMessage: "Fajsúly"
    },
    glucose: {
        id: "ktx.dashboard.total_urine_analysis.glucose",
        defaultMessage: "Glükóz"
    },
    protein: {
        id: "ktx.dashboard.total_urine_analysis.protein",
        defaultMessage: "Fehérje"
    },
    blood: {
        id: "ktx.dashboard.total_urine_analysis.blood",
        defaultMessage: "Vér"
    },
    bilirubin: {
        id: "ktx.dashboard.total_urine_analysis.bilirubin",
        defaultMessage: "Bilirubin"
    },
    urobilinogen: {
        id: "ktx.dashboard.total_urine_analysis.urobilinogen",
        defaultMessage: "Urobilinogen"
    },
    keton: {
        id: "ktx.dashboard.total_urine_analysis.keton",
        defaultMessage: "Keton"
    },
    RBC: {
        id: "ktx.dashboard.total_urine_analysis.rbc",
        defaultMessage: "VVT"
    },
    WBC: {
        id: "ktx.dashboard.total_urine_analysis.wbc",
        defaultMessage: "FVS"
    },
    SC: {
        id: "ktx.dashboard.total_urine_analysis.sc",
        defaultMessage: "LHS"
    },
    bacteria: {
        id: "ktx.dashboard.total_urine_analysis.bacteria",
        defaultMessage: "Baktérium"
    },
    fungus: {
        id: "ktx.dashboard.total_urine_analysis.fungus",
        defaultMessage: "Gomba"
    },
    other: {
        id: "ktx.dashboard.total_urine_analysis.other",
        defaultMessage: "Egyéb"
    }
};
function createTotalUrineAnalysis({ formatMessage, formatMessageMap }, { events }) {
    const event = (0, events_1.findLastEventByQuery)(events, queries_1.complexTypeLabProcedureQueries.totalUrineAnalysis);
    if (event === undefined) {
        return undefined;
    }
    const v = event.value;
    const pH = {
        type: "list-item",
        label: formatMessage(messages.pH),
        value: `${v.pH}`
    };
    const gravity = {
        type: "list-item",
        label: formatMessage(messages.gravity),
        value: `${v.gravity}`
    };
    const glucose = {
        type: "list-item",
        label: formatMessage(messages.glucose),
        value: formatMessageMap(totalUrineAnalysis_1.glucoseMessages, v.glucose)
    };
    const protein = {
        type: "list-item",
        label: formatMessage(messages.protein),
        value: formatMessageMap(totalUrineAnalysis_1.proteinMessages, v.protein)
    };
    const blood = {
        type: "list-item",
        label: formatMessage(messages.blood),
        value: formatMessageMap(totalUrineAnalysis_1.bloodMessages, v.blood)
    };
    const bilirubin = {
        type: "list-item",
        label: formatMessage(messages.bilirubin),
        value: formatMessageMap(totalUrineAnalysis_1.bilirubinMessages, v.bilirubin)
    };
    const urobilinogen = {
        type: "list-item",
        label: formatMessage(messages.urobilinogen),
        value: formatMessageMap(totalUrineAnalysis_1.urobilinogenMessages, v.urobilinogen)
    };
    const keton = {
        type: "list-item",
        label: formatMessage(messages.keton),
        value: formatMessageMap(totalUrineAnalysis_1.ketonMessages, v.keton)
    };
    const RBC = {
        type: "list-item",
        label: formatMessage(messages.RBC),
        value: `${v.RBC}`
    };
    const WBC = {
        type: "list-item",
        label: formatMessage(messages.WBC),
        value: `${v.WBC}`
    };
    const SC = {
        type: "list-item",
        label: formatMessage(messages.SC),
        value: `${v.SC}`
    };
    const bacteria = {
        type: "list-item",
        label: formatMessage(messages.bacteria),
        value: `${v.bacteria}`
    };
    const fungus = {
        type: "list-item",
        label: formatMessage(messages.fungus),
        value: `${v.fungus}`
    };
    const items = [
        pH,
        gravity,
        glucose,
        protein,
        blood,
        bilirubin,
        urobilinogen,
        keton,
        RBC,
        WBC,
        SC,
        bacteria,
        fungus
    ];
    if (v.other) {
        const other = {
            type: "list-item",
            label: formatMessage(messages.other),
            value: `${v.other}`
        };
        items.push(other);
    }
    const { origin } = event;
    return {
        type: "list",
        attachments: (0, events_1.mapEventsToAttachments)(event),
        origin,
        label: formatMessage(messages.totalUrineAnalysis),
        items
    };
}
